/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { UserAccountType } from './UserAccountType';
import {
    UserAccountTypeFromJSON,
    UserAccountTypeFromJSONTyped,
    UserAccountTypeToJSON,
} from './UserAccountType';
import type { UserStateOfUse } from './UserStateOfUse';
import {
    UserStateOfUseFromJSON,
    UserStateOfUseFromJSONTyped,
    UserStateOfUseToJSON,
} from './UserStateOfUse';

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastLoginTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    profilePictureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    readonly fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserDto
     */
    assignedRoles: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDto
     */
    assignedRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    rolesUpdated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    description?: string | null;
    /**
     * 
     * @type {UserAccountType}
     * @memberof UserDto
     */
    accountType?: UserAccountType;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    mobileNumber?: string | null;
    /**
     * 
     * @type {UserStateOfUse}
     * @memberof UserDto
     */
    state?: UserStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof UserDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof UserDto
     */
    possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof UserDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastSeen?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    lastSeenNow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    firstSignIn?: boolean;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof UserDto
     */
    creatorUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof UserDto
     */
    lastModifierUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof UserDto
     */
    editingUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    eulaAccepted?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof UserDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    $type?: UserDtoTypeEnum;
}


/**
 * @export
 */
export const UserDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationUsersDtoUserDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UserDtoTypeEnum = typeof UserDtoTypeEnum[keyof typeof UserDtoTypeEnum];


/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value?: unknown): value is UserDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UserDtoTypeEnum)[0];
}

export function UserDtoFromJSON(json: any): UserDto {
    return UserDtoFromJSONTyped(json, false);
}

export function UserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'userName': json['userName'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'middleName': !exists(json, 'middleName') ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'emailAddress': json['emailAddress'],
        'lastLoginTime': !exists(json, 'lastLoginTime') ? undefined : json['lastLoginTime'],
        'profilePictureId': !exists(json, 'profilePictureId') ? undefined : json['profilePictureId'],
        'fullName': json['fullName'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'assignedRoles': json['assignedRoles'],
        'assignedRolesDisplayNames': !exists(json, 'assignedRolesDisplayNames') ? undefined : json['assignedRolesDisplayNames'],
        'rolesUpdated': !exists(json, 'rolesUpdated') ? undefined : json['rolesUpdated'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'accountType': !exists(json, 'accountType') ? undefined : UserAccountTypeFromJSON(json['accountType']),
        'mobileNumber': !exists(json, 'mobileNumber') ? undefined : json['mobileNumber'],
        'state': !exists(json, 'state') ? undefined : UserStateOfUseFromJSON(json['state']),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'lastSeen': !exists(json, 'lastSeen') ? undefined : json['lastSeen'],
        'lastSeenNow': !exists(json, 'lastSeenNow') ? undefined : json['lastSeenNow'],
        'firstSignIn': !exists(json, 'firstSignIn') ? undefined : json['firstSignIn'],
        'creatorUser': !exists(json, 'creatorUser') ? undefined : HistoryDtoUserFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : HistoryDtoUserFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : HistoryDtoUserFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'eulaAccepted': !exists(json, 'eulaAccepted') ? undefined : json['eulaAccepted'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UserDtoToJSON(value?: UserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'userName': value.userName,
        'title': value.title,
        'firstName': value.firstName,
        'middleName': value.middleName,
        'lastName': value.lastName,
        'emailAddress': value.emailAddress,
        'lastLoginTime': value.lastLoginTime,
        'profilePictureId': value.profilePictureId,
        'iuid': value.iuid,
        'phoneNumber': value.phoneNumber,
        'assignedRoles': value.assignedRoles,
        'assignedRolesDisplayNames': value.assignedRolesDisplayNames,
        'rolesUpdated': value.rolesUpdated,
        'description': value.description,
        'accountType': UserAccountTypeToJSON(value.accountType),
        'mobileNumber': value.mobileNumber,
        'state': UserStateOfUseToJSON(value.state),
        'isAvailable': value.isAvailable,
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'possibleActions': value.possibleActions === undefined ? undefined : (value.possibleActions === null ? null : (value.possibleActions as Array<any>).map(PossibleActionDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'lastSeen': value.lastSeen,
        'lastSeenNow': value.lastSeenNow,
        'firstSignIn': value.firstSignIn,
        'creatorUser': HistoryDtoUserToJSON(value.creatorUser),
        'lastModifierUser': HistoryDtoUserToJSON(value.lastModifierUser),
        'editingUser': HistoryDtoUserToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'eulaAccepted': value.eulaAccepted,
        'origin': EntityOriginToJSON(value.origin),
        '$type': value.$type,
    });
}

